import React from 'react';
import { Button, IconButton, Menu as MuiMenu, MenuItem, useMediaQuery } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from "react-router-dom";

export default function Menu(props: any) {
  const role_id = localStorage.getItem('role_id');
  const isMobile = useMediaQuery('(max-width:768px)');
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const isLoggedIn = !!role_id;

  const menuItems = role_id !== '100' ? [
    { label: 'INICIO', path: '/' },
    { label: 'QUIENES SOMOS', path: '/quienes-somos' },
    { label: 'BUSCADOR DE ENFERMERAS', path: '/enfermeras' },
    ...(isLoggedIn ? [{ label: 'MENSAJES', path: '/mensajes' }] : []),
    { label: 'BLOG', path: '/blog' },
    { label: 'PREGUNTAS FRECUENTES', path: '/preguntas-frecuentes' },
  ] : [
    { label: 'Banners', path: '/banners' },
    { label: 'Usuarios', path: '/usuarios' },
    { label: 'Blog', path: '/admin-blog' },
    { label: 'Mensajes', path: '/admin-mensajes' },
    { label: 'Configuración', path: '/configuracion' },
    { label: 'Distintivos', path: '/distintivos' },
    { label: 'Empresas', path: '/empresas' },
    { label: 'Calificaciones', path: '/calificaciones' },
    { label: 'Gestión de Usuarios', path: '/reporte-enfermeras' },
    { label: 'Contactos WhatsApp', path: '/contactos-whatsapp' },
    { label: 'Redirecciones', path: '/redirecciones' },
  ];

  return (
    <div>
      {isMobile ? (
        <>
          <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleMenuClick}>
            <MenuIcon style={{ color: 'white' }} />
          </IconButton>
          <MuiMenu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            {menuItems.map((item) => (
              <MenuItem
                key={item.label}
                component={Link}
                to={item.path}
                onClick={handleMenuClose}
              >
                {item.label}
              </MenuItem>
            ))}
          </MuiMenu>
        </>
      ) : (
        <div className="menu-buttons">
          {menuItems.map((item) => (
            <Button
              key={item.label}
              component={Link}
              to={item.path}
              style={{ color: 'white' }}
            >
              {item.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}